/* eslint-disable no-useless-escape */
export function isPhoneNumber(value) {
  return /^\+(\d|\X){11}$/.test(value);
}
export function formatPhoneNumber(value) {
  if (isPhoneNumber(value)) {
    return `${value.slice(2, 5)}-${value.slice(5, 8)}-${value.slice(8)}`;
  } else {
    return value;
  }
}
